import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Button, Tabs, Grid, Space } from "antd";
import "../../../styles/organizer/organizerheader.css";
import { Link, useNavigate, useParams } from "react-router-dom";

import {
  followFunction,
  unFollowProfile,
  getactivefollowfollowers,
  checkIsAccepted,
  fallbackprofile
} from "../../../common/Utils";
import Loader from "../../../common/cards/Loader";
import { KEYS } from "../../../Config/Keys";
import FadeInImage from "../../../common/Images/FadeInImage";
import { useDispatch, useSelector } from "react-redux";
import { PROFILE, setProfile } from "../../../Store/Features/ProfileSlice";
import { useFetchProfile } from "../../../common/hooks/useFetchProfile";
import { useCurrentPage } from "../../../common/hooks/useCurrentPage";
import useVariables from "../../../common/hooks/useVariables";
import { ROLES } from "../../../Config/helpers/constants";

const { useBreakpoint } = Grid;
const { TabPane } = Tabs;

const OrganizerTNav = ({ userId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [isFollowing, setisFollowing] = useState(false);
  const [accepted, setaccpted] = useState(false);

  const { id } = useParams();
  const { viewer, PID } = useVariables();
  const { url, other } = useCurrentPage();

  //id =other user, viewer=current user
  let fetchid = userId ? userId : id ? id : viewer?.id;

  //api call for fetching profile
  const { profileLoding } = useFetchProfile(fetchid, "organizer", setisFollowing);

  //fetched organizer
  let organizer = useSelector(PROFILE);

  const followers = getactivefollowfollowers(organizer?.followers);
  const followings = getactivefollowfollowers(organizer?.followings);

  useEffect(() => {
    //checking for follow request
    checkIsAccepted(setaccpted, followers, viewer);
  }, [followers?.length, isFollowing]);

  const FollowFollowingButton = () => {
    return (
      <Row justify="center">
        <p>
          {/* {alert(viewer)} */}
          <Button
            onClick={() =>
              navigate(
                `/${
                  viewer?.flag === ROLES.player
                    ? "player"
                    : viewer?.flag === ROLES.sponsor
                    ? "sponsor"
                    : "organizer"
                }/messages/chat`,
                {
                  state: {
                    id: id,
                    role: "organizer",
                    profilepic: organizer.profile,
                    name: organizer.name
                  }
                }
              )
            }
            className="profilebuttons blueButton btnMobileDimensions"
            style={{
              height: "auto",
              padding: "6px 10px",
              margin: "0",
              color: "white",
              marginRight: "5px"
            }}>
            Chat
          </Button>
        </p>
        <p>
          {isFollowing ? (
            <Button
              loading={loading === "unfollow" && true}
              onClick={() => {
                unFollowProfile(
                  organizer,
                  null,
                  "organizer",
                  setloading,
                  setisFollowing,
                  "otherprofile",
                  setProfile,
                  dispatch,
                  setaccpted
                );
              }}
              className="  profilebuttons blueButton btnMobileDimensions"
              style={{
                height: "auto",
                padding: "6px 10px",
                margin: "0",
                color: "white"
              }}>
              {accepted ? "UnFollow" : "Cancel Request"}
            </Button>
          ) : (
            <Button
              loading={loading === "follow" && true}
              onClick={() =>
                followFunction(
                  id,
                  setloading,
                  setisFollowing,
                  null,
                  setProfile,
                  dispatch,
                  setaccpted
                )
              }
              className="addtocalendar profilebuttons btnMobileDimensions"
              style={{
                height: "auto",
                padding: "6px 10px",
                margin: "0",
                color: "white"
              }}>
              Follow
            </Button>
          )}
        </p>
      </Row>
    );
  };
  const EditButton = () => {
    return (
      <p>
        <Button
          onClick={() =>
            navigate(`/organizer/editprofile/${organizer?._id}`, {
              state: "organizer"
            })
          }
          className="addtocalendar profilebuttons btnMobileDimensions"
          style={{
            height: "auto",
            padding: "6px 10px",
            margin: "0",
            color: "white"
          }}>
          Edit Profile
        </Button>
      </p>
    );
  };

  //checking if current user id !== fetched user id, (to toggle follow and edit buttons)
  const condition = id !== viewer?.id;
  const screens = useBreakpoint();
  return (
    <Fragment>
      {profileLoding ? <Loader fullpage loading="white" /> : null}

      <Row>
        <Col span={24} className="toheader">
          <FadeInImage
            type={"Fadecover"}
            preview
            className="tocover"
            src={KEYS.API + "/" + organizer?.cover || organizer?.coverpic}
          />
          <FollowersFollowingDataComp
            url={url}
            other={other}
            organizer={organizer}
            followers={followers}
            followings={followings}
            id={id}
          />
        </Col>
      </Row>

      <Row wrap="wrap" align="top" className="tosubnav tosubnav1">
        <Col
          style={{
            paddingTop: other && organizer?._id === PID ? "6px" : undefined
          }}
          className="tosubnavcenter"
          xl={4}
          lg={4}
          md={4}
          sm={6}
          xs={24}>
          <div className="abs">
            <FadeInImage
              preview
              type="Fadeprofile"
              fallaback={fallbackprofile}
              src={KEYS.API + "/" + viewer?.profile}
            />
          </div>
        </Col>
        <Col
          style={{
            paddingTop: other && organizer?._id === PID ? "6px" : undefined
          }}
          className="tosubnavcenter"
          xl={4}
          lg={4}
          md={4}
          sm={6}
          xs={24}>
          <Space direction="vertical" size="small" align="center">
            <h2 className="toname">
              {organizer?.name || "Dummy name"}
              <br />
              {organizer?.username && (
                <span className="m-0" style={{ fontSize: "12px", color: "gray" }}>
                  ({organizer?.username || "Dummy username"})
                </span>
              )}
            </h2>
          </Space>
        </Col>

        <Col
          style={{
            paddingTop: other && organizer?._id === PID ? "6px" : undefined
          }}
          className="tosubnavcenter"
          xl={16}
          lg={16}
          md={4}
          sm={6}
          xs={24}>
          {screens["sm"] && condition ? (
            <Fragment>
              {other ? (
                <Col style={{ marginLeft: "auto" }} className="tosubnavcenter d-md-none">
                  <FollowFollowingButton />
                </Col>
              ) : (
                <Col style={{ marginLeft: "auto" }} className="tosubnavcenter d-md-none">
                  <EditButton />
                </Col>
              )}
            </Fragment>
          ) : null}
        </Col>
      </Row>
      <SubLinksWrapper
        organizer={organizer}
        other={other}
        url={url}
        PID={PID}
        id={id}
        condition={condition}
        EditButton={EditButton}
        FollowFollowingButton={FollowFollowingButton}
      />
      <XsButtonsRow
        other={other}
        condition={condition}
        EditButton={EditButton}
        FollowFollowingButton={FollowFollowingButton}
      />
    </Fragment>
  );
};

const FollowersFollowingDataComp = ({ url, other, organizer, followers, followings, id }) => {
  return (
    <div className="tofollower">
      <div className={url === "followers" ? "totitle totitleBlue" : "totitle"}>
        {other ? (
          <Link to={`/view/organizer/${organizer?._id || id}/followers`}>
            <p className="toFollow">Followers</p>
            <p className="tocount">{followers?.length}</p>
          </Link>
        ) : (
          <Link to={`/organizer/followers`}>
            <p className="toFollow">Followers</p>
            <p className="tocount"> {followers?.length}</p>
          </Link>
        )}
      </div>
      <div className={url === "followings" ? "totitle totitleBlue" : "totitle"}>
        {other ? (
          <Link to={`/view/organizer/${organizer?._id || id}/followings`}>
            <p className="toFollow"> Followings</p>
            <p className="tocount"> {followings?.length}</p>
          </Link>
        ) : (
          <Link to={`/organizer/followings`}>
            <p className="toFollow"> Followings</p>
            <p className="tocount"> {followings?.length}</p>
          </Link>
        )}
      </div>
    </div>
  );
};
const XsButtonsRow = ({ condition, other, EditButton, FollowFollowingButton }) => {
  return condition ? (
    <Row className="tosubnav d-none d-md-block">
      <Col span={24}>
        {other ? (
          <Col style={{ marginLeft: "auto" }} className="tosubnavcenter">
            <FollowFollowingButton />
          </Col>
        ) : (
          <Col style={{ marginLeft: "auto" }} className="tosubnavcenter">
            <EditButton />
          </Col>
        )}
      </Col>
    </Row>
  ) : null;
};

const SubLinksWrapper = ({
  organizer,
  other,
  url,
  PID,
  id,
  condition,
  EditButton,
  FollowFollowingButton
}) => {
  const screens = useBreakpoint();
  return (
    <Fragment>
      {screens["sm"] ? (
        <SubLinksDesktop
          organizer={organizer}
          other={other}
          url={url}
          PID={PID}
          id={id}
          condition={condition}
          EditButton={EditButton}
          FollowFollowingButton={FollowFollowingButton}
        />
      ) : (
        <SubLinksTabs organizer={organizer} other={other} url={url} id={id} />
      )}
    </Fragment>
  );
};
const SubLinksDesktop = ({ organizer, other, url, id }) => {
  return (
    <Col xl={24} lg={24} md={17} sm={15} xs={24} className="header-tabs">
      <Row className="subnavLinks noScroll header-tabs-row">
        <Col className="tosubnavcenter">
          <Link
            to={other ? `/view/organizer/${organizer?._id || id}/timeline` : "/organizer/timeline"}>
            <p className={url === "timeline" ? "toactive" : null}> Timeline</p>
          </Link>
        </Col>

        <Col className="tosubnavcenter">
          <Link to={other ? `/view/organizer/${organizer?._id || id}/media` : "/organizer/media"}>
            <p className={url === "media" ? "toactive" : null}> Media </p>
          </Link>
        </Col>
        {!other && (
          <Col className="tosubnavcenter">
            <Link to="/organizer/wallet">
              <p className={url === "wallet" ? "toactive" : null}>Wallet</p>
            </Link>
          </Col>
        )}
      </Row>
    </Col>
  );
};
const SubLinksTabs = ({ organizer, other, url, id }) => {
  const arr = [
    {
      label: "timeline",
      url: other ? `/view/organizer/${organizer?._id || id}/timeline` : `/organizer/timeline`,
      key: other ? `/view/organizer/${organizer?._id || id}/timeline` : `/organizer/timeline`
    },
    {
      label: "media",
      url: other ? `/view/organizer/${organizer?._id || id}/media` : `/organizer/media`,
      key: other ? `/view/organizer/${organizer?._id || id}/media` : `/organizer/media`
    }
  ];

  if (!other) {
    arr?.push({
      label: "wallet",
      url: "/organizer/wallet",
      key: "/organizer/wallet"
    });
  }

  const navigate = useNavigate();

  return (
    <Tabs
      tabPosition={"top"}
      centered
      activeKey={url}
      size="small"
      onChange={(e) => {
        navigate(e);
      }}
      className="MobileSubNavTabLinks">
      {arr.map(({ label, key }) => (
        <TabPane tab={label} key={`${key}`} />
      ))}
    </Tabs>
  );
};

export default OrganizerTNav;
